import { queryParams } from "$routes/_lib/routing";

export function getOrganisationIdQueryParam() {
  const params = new URLSearchParams(window.location.search);
  return params.get("organisationId");
}

// ############ Organisations ############

export function linkToOrganisationManagement() {
  return "/organisation-management";
}

export function linkToOrganisationsOverview() {
  return `${linkToOrganisationManagement()}/overview`;
}

export function linkToAddNewOrganisation() {
  return `${linkToOrganisationManagement()}/create`;
}

// ############ Organisation ############

export function _linkToOrganisation({
  organisationId = ":organisationId",
} = {}) {
  return `${linkToOrganisationManagement()}/organisation/${organisationId}`;
}

export function linkToOrganisationOverview({
  organisationId,
}: {
  organisationId?: string;
} = {}) {
  return `${_linkToOrganisation({ organisationId })}/overview`;
}

export function linkToEditOrganisation({
  organisationId,
}: {
  organisationId?: string;
} = {}) {
  return `${_linkToOrganisation({ organisationId })}/edit`;
}

// ############ Facilities ############

export function _linkToFacilities() {
  return `${linkToOrganisationManagement()}/facilities`;
}

export function linkToFacilitiesOverview() {
  return `${_linkToFacilities()}/overview`;
}

export function linkToAddNewFacility({
  organisationId,
}: {
  organisationId?: string;
} = {}) {
  return `${_linkToFacilities()}/create${queryParams({ organisationId })}`;
}

export function linkToMyFacility() {
  return `${_linkToFacilities()}/my-facility`;
}

// ############ Facility ############

export function _linkToFacility({ facilityId = ":facilityId" } = {}) {
  return `${_linkToFacilities()}/facility/${facilityId}`;
}

export function linkToAddFacilityUser({
  facilityId,
  organisationId,
}: {
  facilityId?: string;
  organisationId?: string;
} = {}) {
  return `${_linkToFacility({ facilityId })}/add-user${queryParams({
    organisationId,
  })}`;
}

export function linkToFacilityOverview({
  facilityId,
  organisationId,
}: {
  facilityId?: string;
  organisationId?: string;
} = {}) {
  return `${_linkToFacility({ facilityId })}/overview${queryParams({
    organisationId,
  })}`;
}

export function linkToEditFacility({
  facilityId,
  organisationId,
}: {
  facilityId?: string;
  organisationId?: string;
} = {}) {
  return `${_linkToFacility({ facilityId })}/edit${queryParams({
    organisationId,
  })}`;
}

// ############ Facility Users ############

export function _linkToFacilityUser({
  facilityId,
  userId = ":userId",
}: {
  facilityId?: string;
  userId?: string;
} = {}) {
  return `${_linkToFacility({ facilityId })}/user/${userId}`;
}

export function linkToEditFacilityUser({
  facilityId,
  userId,
  organisationId,
}: {
  facilityId?: string;
  userId?: string;
  organisationId?: string;
} = {}) {
  return `${_linkToFacilityUser({ facilityId, userId })}/edit${queryParams({
    organisationId,
  })}`;
}
